import React, { useEffect, useState } from "react";
import "./puja-campaign-text-loader.scss";

export default function TextLoader() {
  const loadingParagraphs = [
    "Maa Durga is blessing your moment…",
    "Adding the spirit of Puja to your photo…",
    "Almost there, get ready for your Selfie with Maa ✨",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % loadingParagraphs.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`flex-row-center PujaCampaignTextLoader`}>
      <p className="animatedText" key={currentIndex}>
        {loadingParagraphs[currentIndex]}
      </p>
    </div>
  );
}
